import React from 'react';
import { motion } from 'framer-motion';
import { MailIcon, GlobeIcon, ArrowRightIcon } from 'lucide-react';
import { SlideLayout, itemVariants } from '../ui/SlideLayout';
export function GetStartedSlide() {
  return <SlideLayout className="text-center relative" data-id="element-165">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-teal/10 blur-[150px] rounded-full pointer-events-none" data-id="element-166" />

      <motion.div variants={itemVariants} className="mb-8 relative z-10" data-id="element-167">
        <h2 className="text-3xl md:text-5xl font-bold text-brand-text mb-4" data-id="element-168">
          We Are Onboarding <br data-id="element-169" />
          <span className="text-brand-teal" data-id="element-170">Design Partners Now</span>
        </h2>
        <p className="text-lg text-brand-text-dim max-w-3xl mx-auto" data-id="element-171">
          We are looking for production AI teams who want to be first to run on
          FPGA-accelerated inference.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto mb-10 relative z-10 text-left" data-id="element-172">
        <motion.div variants={itemVariants} className="bg-brand-bg-card/80 backdrop-blur-sm border border-brand-border rounded-2xl p-6" data-id="element-173">
          <h3 className="text-lg font-bold text-brand-text mb-3 flex items-center gap-2" data-id="element-174">
            <span className="text-brand-teal" data-id="element-175">What you get</span>
          </h3>
          <ul className="space-y-2 text-sm text-brand-text-dim" data-id="element-176">
            <li className="flex items-start gap-2" data-id="element-177">
              <span className="text-brand-teal mt-0.5" data-id="element-178">✓</span> Early access to
              the API
            </li>
            <li className="flex items-start gap-2" data-id="element-179">
              <span className="text-brand-teal mt-0.5" data-id="element-180">✓</span> Preferred
              pricing
            </li>
            <li className="flex items-start gap-2" data-id="element-181">
              <span className="text-brand-teal mt-0.5" data-id="element-182">✓</span> Direct line to
              the engineering team
            </li>
            <li className="flex items-start gap-2" data-id="element-183">
              <span className="text-brand-teal mt-0.5" data-id="element-184">✓</span> Influence on
              model roadmap priority
            </li>
          </ul>
        </motion.div>

        <motion.div variants={itemVariants} className="bg-brand-bg-card/80 backdrop-blur-sm border border-brand-border rounded-2xl p-6" data-id="element-185">
          <h3 className="text-lg font-bold text-brand-text mb-3 flex items-center gap-2" data-id="element-186">
            <span className="text-brand-text-muted" data-id="element-187">What we ask</span>
          </h3>
          <ul className="space-y-2 text-sm text-brand-text-dim" data-id="element-188">
            <li className="flex items-start gap-2" data-id="element-189">
              <span className="text-brand-border mt-0.5" data-id="element-190">■</span> A non-binding
              LOI signaling intent
            </li>
            <li className="flex items-start gap-2" data-id="element-191">
              <span className="text-brand-border mt-0.5" data-id="element-192">■</span> Feedback on
              which models matter most
            </li>
            <li className="flex items-start gap-2" data-id="element-193">
              <span className="text-brand-border mt-0.5" data-id="element-194">■</span> Your specific
              latency targets
            </li>
          </ul>
        </motion.div>
      </div>

      <motion.div variants={itemVariants} className="relative z-10 flex flex-col items-center gap-4" data-id="element-195">
        <a href="mailto:founders@openfpga.ai" className="group flex items-center gap-3 text-2xl md:text-3xl font-bold text-brand-text hover:text-brand-teal transition-colors" data-id="element-196">
          <MailIcon className="w-7 h-7 text-brand-teal group-hover:scale-110 transition-transform" data-id="element-197" />
          founders@openfpga.ai
        </a>

        <a href="https://openfpga.ai" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-lg text-brand-text-dim hover:text-brand-text transition-colors" data-id="element-198">
          <GlobeIcon className="w-5 h-5" data-id="element-199" />
          openfpga.ai
        </a>
      </motion.div>

      <motion.div variants={itemVariants} className="mt-8 relative z-10" data-id="element-200">
        <p className="text-brand-text-muted font-mono text-sm" data-id="element-201">
          One API-key swap. No hardware knowledge. No vendor lock-in.
        </p>
      </motion.div>
    </SlideLayout>;
}